<template>
    <div class="sletect-w-autocomplete" ref="block">
        <div class="sletect-w-autocomplete__input" :class="{ active: showOption, selected: value && value.name }"
            @click="showOptionBlock()">
            <div class="sletect-w-autocomplete__input__content">
                <span>
                    <template v-if="value && value.name">
                        {{ value.name }}
                    </template>
                    <template v-else>
                        {{ placeholder }}
                    </template>
                </span>
                <Icon iconName="chevron-down" width="16" height="16" viewBox="0 0 16 16" strockeWidth="2"
                    class="sletect-w-autocomplete__input__content__icon" />
            </div>
        </div>
        <transition name="fade">
            <div class="sletect-w-autocomplete__option" v-if="showOption">
                <v-autocomplete colspan="1" item-value="client_id" item-text="name" placeholder="Поиск клиентов"
                    no-data-text="Результатов не найдено" :search-input.sync="search" v-model="select"
                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg', maxWidth: '300' }" no-filter="true"
                    class="rounded-lg autocomplete-4-select" append-icon="" hide-no-data hide-details outlined dense background-color="white"
                    style="height: 48px;padding-top: 5px; width: 300px;"                    
                    >
                    <template v-slot:prepend-inner>
                        <v-icon>mdi-magnify</v-icon>
                    </template>
                </v-autocomplete>
                <template v-if="listClient && listClient.client && listClient.client.length == 0">
                    <div class="hint">
                        <template v-if="!searchStart">
                            Введите имя клиента
                        </template>
                        <template v-else>
                            По вашему запросу ничего не найденно
                        </template>
                    </div>
                </template>
                <div class="search-list">
                    <template v-if="listClient && listClient.client">
                        <div class="search-list__item" v-for="client in listClient.client"
                            :key="`client-${client.client_id}`" @click="selected(client)">
                            {{ client.name }}
                        </div>
                    </template>
                    <div class="create-client">
                        <router-link :to="{ name: 'Cashbox' }">
                            Создать клиента
                        </router-link>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
import { clientActionTypes } from '@/store/modules/client';
import { mapState } from "vuex";
export default {
    name: "SelectWithAutocomplete",
    props: {
        placeholder: {
            typeof: String,
            default: 'Выбрать'
        },
        value: {
            typeof: String,
            default: ''
        },

    },
    computed: {
        ...mapState({
            listClient: state => state.client.listClient,
        }),
    },
    data() {
        return {
            search: '',
            sales: [
                { tab: 'Номенклатура' },
                { tab: 'Дополнительно' }
            ],
            client: null,
            itemsClients: [
                {}
                // { title: 'Иванов Иван Иванович', value: '1', img: '/playground_assets/Image-2.png', },
                // { title: 'Иванов Иван Иванович', value: '2', img: '/playground_assets/Image-2.png', },
                // { title: 'Иванов Иван Иванович', value: '3', img: '/playground_assets/Image-2.png', },
            ],
            select: null,
            searchStart: false,
            showOption: false,
        }
    },
    watch: {
        showOption: function (val) {
            if (val) {
                const block = this.$refs.block
                document.addEventListener('click', this.handleClickOutside);
            } else {
                document.removeEventListener('click', this.handleClickOutside);
            }
            return () => {
                document.removeEventListener('click', this.handleClickOutside);
            };
        },
        search() {
            if (!!this.search) {
                this.$set(this, 'searchStart', true)
                this.$store.dispatch(clientActionTypes.searchClient, {
                    client_field: this.search
                })
            }
        },
    },
    methods: {
        showOptionBlock() {
            this.$set(this, 'showOption', true)
        },
        handleClickOutside(e) {
            const block = this.$refs.block
            if (block && block.contains(e.target)) {
                return;
            }
            this.$set(this, 'showOption', false)
        },
        selected: function (item) {
            this.$emit("selected", item);
            this.$emit('input', item)
            this.$set(this, 'showOption', false)
        },
    }
}
</script>
<style lang="scss">
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active до версии 2.1.8 */
    {
    opacity: 0;
    position: absolute;
}

.sletect-w-autocomplete {
    position: relative;

    &__input {
        width: 100%;
        padding: 7px 16px;
        border: 1px solid #E0E0E0;
        border-radius: 12px;
        background: #fff;
        color: #767676;
        transition: all .3s;
        position: relative;
        z-index: 2;

        &:before {
            content: "";
            opacity: 0;
            background: rgba(98, 159, 51, .2);
            width: calc(100% + 8px);
            height: calc(100% + 8px);
            position: absolute;
            left: -4px;
            top: -4px;
            z-index: -1;
            transition: all .3s;
            border-radius: 12px;
        }

        &:after {
            content: "";
            background: #fff;
            width: 100%;
            height: 100%;
            border-radius: 12px;
            position: absolute;
            left: 0;
            top: 0;
            z-index: 0;
        }

        &__content {
            width: 100%;
            display: flex;
            align-items: center;
            position: relative;
            z-index: 2;
            cursor: pointer;

            span {
                flex: 1;
                text-overflow: ellipsis;
                overflow: hidden;
            }

            &__icon {
                transition: all .3s;
            }
        }

        &.active {
            border-color: #629F33;

            &:before {
                opacity: 1;
            }

            .sletect-w-autocomplete__input__content__icon {
                transform: rotate(180deg);
            }

        }

        &.selected {
            color: #1A1A1A;
        }
    }

    &__option {
        width: 100%;
        position: absolute;
        background: #FFFFFF;
        border: 1px solid #E0E0E0;
        box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.12);
        border-radius: 12px;
        margin-top: 4px;
        padding: 20px;
        z-index: 5;

        .search-list {
            border-top: 1px solid #E0E0E0;
            margin-top: 16px;
            padding-top: 16px;
            max-height: 170px;
            overflow-y: auto;

            &::-webkit-scrollbar {
                width: 5px;
                background: #E0E0E0;
            }

            &::-webkit-scrollbar-track {
                background: #fff;
            }

            &::-webkit-scrollbar-thumb {
                background-color: #E0E0E0;
                border-radius: 8px;
                // border: 2px solid #fff;
            }

            &__item {
                width: 100%;
                transition: all .3s;
                padding: 8px 0;
                color: #1A1A1A;
                font-family: 'Circe';
                font-style: normal;
                font-weight: 400;
                font-size: 13px;
                line-height: 16px;
                cursor: pointer;

                &:hover {
                    background: rgba(0, 0, 0, 0.02);
                }
            }

            .create-client {
                padding: 16px 0;

                a {
                    color: #629F33;
                    font-family: 'Circe';
                    font-style: normal;
                    font-weight: 700;
                    font-size: 16px;
                    line-height: 24px;
                    text-decoration: none;
                }
            }
        }

        .hint {
            padding-top: 16px;
            color: #767676;
            font-family: 'Circe';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 16px;
        }
    }
}
</style>